import { Badge } from 'common/src/designSystem/components/badge';
import { Link } from 'common/src/designSystem/components/link';
import { Cell } from 'common/src/designSystem/components/table/cell';
import { VolunteerRegistrationFragment } from 'common/src/generated/types';
import { DelegationsPaths } from 'common/src/util/paths/delegationsPaths';
import * as React from 'react';
import { useHeavent } from '../../../hooks/useHeavent';

interface IVolunteerRegistrationDelegationCategoryProps {
    volunteerRegistration: VolunteerRegistrationFragment;
}

export const VolunteerRegistrationDelegationCategory = (
    props: IVolunteerRegistrationDelegationCategoryProps
) => {
    const {
        params: { organizationId, eventId }
    } = useHeavent();
    const category = props.volunteerRegistration.delegation?.delegationCategory;

    return (
        <Cell>
            {category && (
                <Badge cursor="pointer" ellipsis={true} title={category.name}>
                    <Link
                        to={DelegationsPaths.DELEGATION_CATEGORY({
                            organizationId,
                            eventId,
                            delegationCategoryId: category.id
                        })}
                    >
                        {category.name}
                    </Link>
                </Badge>
            )}
        </Cell>
    );
};
